import _ from 'lodash';
import { apiRemove, apiSearch, apiFetch } from './utility';

const SEARCHING_STATIONS = 'station/SEARCHING';
const SEARCH_FAILED = 'user/SEARCH_FAILED';
const ADDING_STATION = 'user/ADDING_STATION';

const initialState = {
	isSearching: false,
	searchFailed: false,
};

//- Reducers
export default (state = initialState, action) => {
	switch (action.type) {
		case SEARCHING_STATIONS:
			return {
				...state,
				isSearching: true,
			};
		case SEARCH_FAILED:
			return {
				...state,
				searchFailed: true,
			};
		default:
			return state;
	}
};

export const search = (p = {}) => {
	const callback = p.callback || _.noop;
	const params = p.params || {};
	return (dispatch) => {
		dispatch({
			type: SEARCHING_STATIONS,
		});

		apiSearch({
			base: 'station',
			params,
			dispatch,
			callback,
		});
	};
};

export const getStation = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'station.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const addStation = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		dispatch({
			type: ADDING_STATION,
		});

		apiFetch({
			method: 'station.add',
			listNameToUpdate: 'stationIds',
			params,
			dispatch,
			successMessage:
				'Station was added the list successfully. Click continue to return to the stations page',
			onSuccessRedirectTo: '/stations',
			callback: callback,
		});
	};
};

export const updateStation = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'station.update',
			params,
			dispatch,
			successMessage: 'Station updated successfully. Click continue to return to the stations page',
			onSuccessRedirectTo: '/stations',
			callback: callback,
		});
	};
};

export const remove = ({ stationId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: 'station',
			id: stationId,
			dispatch,
			callback,
		});
	};
};
